module.exports = __webpack_public_path__ + "static/media/timelapse_27.d4dcbc0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_27.jpg
// module id = 985
// module chunks = 0